import {
    Alimentacao,
    Refeicao,
    Natal,
    Cultura,
    AlimentacaoDisabled,
    CulturaDisabled,
    RefeicaoDisabled,
    NatalDisabled,
    Tudo,
    Default
} from 'assets/img/cards'

import PodMenu from 'assets/img/card-menu/pod-menu.png'

import {
    AlimentacaoSmall,
    RefeicaoSmall,
    CulturaSmall,
    DefaultSmall
} from 'assets/img/small-cards'

import { BANCODOBRASIL, BRADESCO } from '../constants/banks'
import * as product from '../constants/product-types'

export default class StringFormat {
    static formatCNPJ(cnpj) {
        cnpj = StringFormat.justNumber(cnpj)
        cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2')
        cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2')
        cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2')
        cnpj = cnpj.replace(
            /([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}-?[0-9]{2})(.*)/,
            '$1'
        )
        return cnpj
    }

    static formatCPF(cpf) {
        cpf = cpf.replace(/\D/g, '')
        cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
        cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
        cpf = cpf.replace(/(\d{3})(\d)/, '$1-$2')
        cpf = cpf.replace(/([0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2})(.*)/, '$1')
        return cpf
    }

    static formatCEP(cep) {
        cep = cep.replace(/\D/g, '')
        cep = cep.replace(/(\d{5})(\d)/, '$1-$2')
        cep = cep.replace(/([\d|-]{9})(.*)/, '$1')
        return cep
    }

    static formatDate(date, max = null) {
        date = date.replace(/\D/g, '')
        if (max) {
            date = date.substring(0, max)
        }
        date = date.replace(/(\d{2})(\d)/, '$1/$2')
        date = date.replace(/(\d{2})(\d)/, '$1/$2')
        date = date.replace(/(\d{2}\/\d{2}\/\d{4})(.*)/, '$1')
        return date
    }

    static justNumber(num) {
        return num.replace(/\D/g, '')
    }

    static justAlphaNumeric(text) {
        text = text.replace(
            /[@~`()_£¢¬!#$%^&*+=\-[\]\\':;.,/{}|"<>?¨ºª¹²³§]/gi,
            ''
        )
        return text
    }

    static companyName(text) {
        text = text.replace(/[@()_£¢¬!$%*+=[\]\\':;.,{}|"<>?¨ºª¹²³§]/gi, '')
        return text
    }

    static convertToMonetary(num, max = null) {
        if (!num) return num
        let value = num.replace(/\D/g, '')
        if (max) {
            value = value.substring(0, max)
        }

        value = (value / 100).toFixed(2)
        value = value.replace('.', ',')
        value = value.replace(/(\d)(\d{3})(\d{3})(\d{3}),/g, '$1.$2.$3.$4,')
        value = value.replace(/(\d)(\d{3})(\d{3}),/g, '$1.$2.$3,')
        value = value.replace(/(\d)(\d{3}),/g, '$1.$2,')
        num = value
        return 'R$ ' + num
    }

    static removeMaskDocument(doc) {
        return doc.replace(/(\.|\/|-)/g, '')
    }

    static removeMaskNumber(value) {
        return value.replace(/(\.|\/|,)/g, '')
    }

    static removeMaskCurrency(value) {
        return parseFloat(
            value
                .replace('R$', '')
                .replace(/(\.)/g, '')
                .replace(',', '.')
                .trim()
        ).toFixed(2)
    }

    static justCharacters(text) {
        return text.replace(/\d/g, '')
    }

    static formatPhone(phone) {
        const rawPhone = phone.replace(/\D/g, '')

        phone = rawPhone
            .replace(/\D/g, '')
            .replace(/(\d{10,11})(.*)/g, '$1')
            .replace(/^(\d{2})(\d)/g, '($1)$2')

        const regex =
            rawPhone.length < 11
                ? /^(\(\d{2}\))(\d{4})(\d)/g
                : /^(\(\d{2}\))(\d{5})(\d)/g

        return phone.replace(regex, '$1$2-$3')
    }

    static maxLength = (value, max) => {
        return value.substring(0, max)
    }

    static removeSpecialCharacterMask(text) {
        return text.replace(/[^a-zA-Z0-9-]+/gi, '')
    }

    static replaceSpecialCharacter(text) {
        text = text.replace(/[ÀÁÂÃÄÅ]/g, 'A')
        text = text.replace(/[àáâãäå]/g, 'a')
        text = text.replace(/[ÈÉÊË]/g, 'E')
        text = text.replace(/[éèẽê]/g, 'e')
        text = text.replace(/[íìĩî]/g, 'i')
        text = text.replace(/[ÍÌĨÎ]/g, 'I')
        text = text.replace(/[óòõô]/g, 'o')
        text = text.replace(/[ÓÒÕÔ]/g, 'O')
        text = text.replace(/[úùũû]/g, 'u')
        text = text.replace(/[ÚÙŨÛ]/g, 'U')
        text = text.replace(/[ç]/g, 'c')
        text = text.replace(/[Ç]/g, 'C')
        return text
    }

    static renderDifferentImg = (code) => {
        switch (code) {
            case product.MEAL:
                return RefeicaoSmall
            case product.FEED:
                return AlimentacaoSmall
            case product.CULTURE:
                return CulturaSmall
            default:
                return DefaultSmall
        }
    }

    static renderTraditionalImg = (code) => {
        switch (code) {
            case product.MEAL:
                return Refeicao
            case product.FEED:
                return Alimentacao
            case product.CHRISTMAS:
                return Natal
            case product.CULTURE:
                return Cultura
            case product.TUDO:
                return Tudo
            case product.POD:
                return PodMenu
            default:
                return Default
        }
    }

    static renderAlternateImg = (code) => {
        switch (code) {
            case product.MEAL:
                return Refeicao
            case product.FEED:
                return Alimentacao
            case product.CHRISTMAS:
                return Natal
            case product.CULTURE:
                return Cultura
            case product.TUDO:
                return Tudo
            case product.POD:
                return PodMenu
            default:
                return Default
        }
    }

    static cardKind = (code) => {
        switch (code) {
            case product.MEAL:
                return 'Meal'
            case product.FEED:
                return 'Feed'
            case product.CHRISTMAS:
                return 'Christmas'
            case product.CULTURE:
                return 'Culture'
            case product.POD:
                return 'POD'
            case product.TUDO:
                return 'Tudo'
            default:
                break
        }
    }

    static renderUnavaibleProductCode = (name) => {
        switch (name) {
            case 'NATAL':
                return product.CHRISTMAS
            case 'MULTIBENEFICIOS':
                return product.MULTIBENEFITS
            case 'POD':
                return product.POD
            case 'TUDO':
                return product.TUDO
            default:
                break
        }
    }

    static renderUnavaibleProduct = (id) => {
        switch (id) {
            case product.CHRISTMAS:
                return 'NATAL'
            case product.MULTIBENEFITS:
                return 'MULTIBENEFICIOS'
            case product.POD:
                return 'POD'
            case product.TUDO:
                return 'TUDO'
            default:
                break
        }
    }

    static renderImgDisabled = (code) => {
        switch (code) {
            case product.MEAL:
                return RefeicaoDisabled
            case product.FEED:
                return AlimentacaoDisabled
            case product.CHRISTMAS:
                return NatalDisabled
            case product.CULTURE:
                return CulturaDisabled
            default:
                break
        }
    }

    static renderTerms = (code) => {
        switch (code) {
            case product.MEAL:
                return 'dos Produtos Alelo - Anexo Alelo Refeição'
            case product.FEED:
                return 'dos Produtos Alelo - Anexo Alelo Alimentação'
            case product.CHRISTMAS:
                return 'dos Produtos Alelo - Anexo Alelo Natal'
            case product.CULTURE:
                return 'dos Produtos Alelo - Anexo Alelo Cultura'
            case product.POD:
                return 'do Alelo Pod'
            case product.TUDO:
                return 'do Alelo Tudo'
            default:
                return ''
        }
    }

    static nameProducts = (code) => {
        switch (code) {
            case product.MEAL:
                return 'Alelo Refeição'
            case product.FEED:
                return 'Alelo Alimentação'
            case product.CHRISTMAS:
                return 'Alelo Natal'
            case product.CULTURE:
                return 'Alelo Cultura'
            case product.POD:
                return 'Alelo POD'
            case product.TUDO:
                return 'Alelo Tudo'
            default:
                return ''
        }
    }

    static nameProductType = (code) => {
        switch (code) {
            case product.MEAL:
                return 'REFEICAO'
            case product.FEED:
                return 'ALIMENTACAO'
            case product.CHRISTMAS:
                return 'NATAL'
            case product.CULTURE:
                return 'CULTURA'
            case product.TUDO:
                return 'TUDO'
            case product.POD:
                return 'POD'
            default:
                break
        }
    }

    static nameProductKind = (code) => {
        switch (code) {
            case product.MEAL:
                return 'meal'
            case product.FEED:
                return 'feed'
            case product.CHRISTMAS:
                return 'christmas'
            case product.CULTURE:
                return 'culture'
            default:
                break
        }
    }

    static formatCreditCard(value) {
        value = value.replace(/\D/g, '')
        value = value.replace(/^(\d{4})(\d)/g, '$1.$2')
        value = value.replace(/^(\d{4}).(\d{4})(\d)/g, '$1.$2.$3')
        value = value.replace(/^(\d{4}).(\d{4}).(\d{4})(\d)/g, '$1.$2.$3.$4')
        value = value.replace(
            /^(\d{4}).(\d{4}).(\d{4}).(\d{4})(.*)/g,
            '$1.$2.$3.$4'
        )
        return value
    }

    static capitalize(value) {
        return value
            .split(' ')
            .map((v) => v.charAt(0).toUpperCase() + v.slice(1).toLowerCase())
            .join(' ')
    }

    static formatPartialDate(date) {
        date = date.replace(/\D/g, '')
        date = date.replace(/(\d{2})(\d)/, '$1/$2')
        date = date.replace(/(\d{2}\/\d{4})(.*)/, '$1')
        return date
    }

    static formatCvv(value) {
        value = value.replace(/\D/g, '')
        value = value.replace(/^(\d{3})(.*)/g, '$1')
        return value
    }

    static simpleNameProducts = (code) => {
        switch (code) {
            case product.MEAL:
                return 'alelo-refeicao'
            case product.FEED:
                return 'alelo-alimentacao'
            case product.CHRISTMAS:
                return 'alelo-natal'
            case product.CULTURE:
                return 'alelo-cultura'
            default:
                break
        }
    }

    static tagCheckterms = (code) => {
        switch (code) {
            case product.MEAL:
                return 'contratacao-do-alelo-refeicao'
            case product.FEED:
                return 'contratacao-do-alelo-alimentacao'
            case product.CHRISTMAS:
                return 'contratacao-do-alelo-natal'
            case product.CULTURE:
                return 'contratacao-do-alelo-cultura'
            case 0:
                return 'uso-do-sistema-de-pedidos-alelo'
            default:
                break
        }
    }

    static wcmNameProducts = (code) => {
        switch (code) {
            case product.MEAL:
                return 'refeicao'
            case product.FEED:
                return 'alimentacao'
            case product.CHRISTMAS:
                return 'natal'
            case product.CULTURE:
                return 'cultura'
            case product.POD:
                return 'alelo-pod'
            case product.TUDO:
                return 'alelo-tudo'
            default:
                break
        }
    }

    static productRoutesToProductCode = (name) => {
        switch (name) {
            case 'refeicao':
                return product.MEAL
            case 'alimentacao':
                return product.FEED
            case 'natal':
                return product.CHRISTMAS
            case 'cultura':
                return product.CULTURE
            case 'alelo-pod':
                return product.POD
            case 'alelo-tudo':
                return product.TUDO
            default:
                break
        }
    }

    static bankPhone(bank) {
        switch (bank) {
            case 'bancodobrasil':
                return '4003-3665'
            case 'bradesco':
                return '4003-3225'
            default:
                return '4003-3663'
        }
    }

    static bankAbbreviation(bank) {
        switch (bank) {
            case BRADESCO:
                return 'BR'
            case BANCODOBRASIL:
                return 'BB'
            default:
                return 'AL'
        }
    }

    static bankAbbrevToGetProducts(bank) {
        switch (bank) {
            case BRADESCO:
                return 'BRA'
            case BANCODOBRASIL:
                return 'BB'
            default:
                return ''
        }
    }

    static justNumberClearZero(value, max) {
        const numericValue = this.justNumber(value)
        if (numericValue.length > max && numericValue[0] === '0') {
            return numericValue.substr(1, 4)
        }
        return numericValue
    }

    static formatStringJoin(array) {
        if (array.length === 1) {
            return array.map((prod) => StringFormat.nameProducts(prod))
        }

        if (array.length === 2) {
            return array
                .map((prod) => StringFormat.nameProducts(prod))
                .join(' e ')
        }

        if (array.length >= 3) {
            let newArray = array.map((prod) => StringFormat.nameProducts(prod))
            return (
                newArray.slice(0, newArray.length - 1).join(', ') +
                ' e ' +
                newArray[newArray.length - 1]
            )
        }
    }
}
